import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/hero-saga/ranks';
import { camelizeKeys } from '~/utils/helpers';
import { ResponseTransformer } from '../ResponseTransformer';

const rankApi = {
    index: async () => {
        const { data } = await http.get(`${API_PREFIX}`);

        return camelizeKeys(data);
    },

    create: async () => {
        let { data } = await http.get(`${API_PREFIX}/create`);
        data = new ResponseTransformer(data);
        data.camelizeKeys();

        return data;
    },

    store: async (body) => {
        await http.post(`${API_PREFIX}`, body, {});
    },

    show: async (id) => {
        let { data } = await http.get(`${API_PREFIX}/${id}`);
        data = new ResponseTransformer(data);
        data.camelizeKeys();

        return data;
    },

    update: async (id, body) => {
        await http.put(`${API_PREFIX}/${id}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/${id}`);
    },
};

export default rankApi;
